import {
  OutcomesBreadcrumbSelectedEvent,
  OutcomesDateRangeFilteredEvent,
  OutcomesDrillDownBarSelectedEvent,
  OutcomesDrillDownSelectedEvent,
  OutcomesHomeSelectedEvent,
  OutcomesImpactReportDownloadedEvent,
  OutcomesImpactReportDownloadSelectedEvent,
  OutcomesImpactReportSelectedEvent,
  OutcomesMetricSelectedEvent,
  OutcomesMetricVisibilityTabSelectedEvent,
  OutcomesMetricVisibilityToggledEvent,
  OutcomesOrgVisibilityDoneSelectedEvent,
  OutcomesProductFilteredEvent,
  OutcomesRawDataDownloadedEvent,
  OutcomesRawDataDownloadSelectedEvent,
  OutcomesSearchEvent,
} from "@models/tracking/xapi-events";
import container from "@src/container";

/**
 * Outcomes dashboard tracking functions.
 *
 * Kept in a sibling module and re-exported from `event-trackers.js` so call
 * sites still import from the one facade while the outcomes block stays
 * separable.
 *
 * @module lib/event-trackers.outcomes
 */

const { xApiTrackingService } = container;

export const trackOutcomesDrillDownSelected = async (
  scopeId,
  scopeName,
  extensions = {}
) => {
  await xApiTrackingService.trackEvent(
    new OutcomesDrillDownSelectedEvent(scopeId, scopeName, extensions)
  );
};

export const trackOutcomesDrillDownBarSelected = async (
  scopeId,
  scopeName,
  extensions = {}
) => {
  await xApiTrackingService.trackEvent(
    new OutcomesDrillDownBarSelectedEvent(scopeId, scopeName, extensions)
  );
};

export const trackOutcomesBreadcrumbSelected = async (
  objectId,
  extensions = {}
) => {
  await xApiTrackingService.trackEvent(
    new OutcomesBreadcrumbSelectedEvent(objectId, extensions)
  );
};

export const trackOutcomesHomeSelected = async (objectId) => {
  await xApiTrackingService.trackEvent(new OutcomesHomeSelectedEvent(objectId));
};

export const trackOutcomesMetricSelected = async (
  objectId,
  metricName,
  extensions = {}
) => {
  await xApiTrackingService.trackEvent(
    new OutcomesMetricSelectedEvent(objectId, metricName, extensions)
  );
};

export const trackOutcomesMetricVisibilityToggled = async (
  objectId,
  metricName,
  extensions = {}
) => {
  await xApiTrackingService.trackEvent(
    new OutcomesMetricVisibilityToggledEvent(objectId, metricName, extensions)
  );
};

export const trackOutcomesMetricVisibilityTabSelected = async (
  objectId,
  tabLabel,
  extensions = {}
) => {
  await xApiTrackingService.trackEvent(
    new OutcomesMetricVisibilityTabSelectedEvent(objectId, tabLabel, extensions)
  );
};

export const trackOutcomesProductFiltered = async (
  objectId,
  objectName,
  extensions = {}
) => {
  await xApiTrackingService.trackEvent(
    new OutcomesProductFilteredEvent(objectId, objectName, extensions)
  );
};

export const trackOutcomesDateRangeFiltered = async (
  objectId,
  objectName,
  extensions = {}
) => {
  await xApiTrackingService.trackEvent(
    new OutcomesDateRangeFilteredEvent(objectId, objectName, extensions)
  );
};

export const trackOutcomesOrgVisibilityDoneSelected = async (
  objectId,
  objectName,
  extensions = {}
) => {
  await xApiTrackingService.trackEvent(
    new OutcomesOrgVisibilityDoneSelectedEvent(objectId, objectName, extensions)
  );
};

export const trackOutcomesSearch = async (
  searchBarId,
  searchBarName,
  extensions = {}
) => {
  await xApiTrackingService.trackEvent(
    new OutcomesSearchEvent(searchBarId, searchBarName, extensions)
  );
};

export const trackOutcomesImpactReportSelected = async (
  objectId,
  extensions = {}
) => {
  await xApiTrackingService.trackEvent(
    new OutcomesImpactReportSelectedEvent(objectId, extensions)
  );
};

export const trackOutcomesImpactReportDownloadSelected = async (
  objectId,
  extensions = {}
) => {
  await xApiTrackingService.trackEvent(
    new OutcomesImpactReportDownloadSelectedEvent(objectId, extensions)
  );
};

export const trackOutcomesImpactReportDownloaded = async (
  objectId,
  extensions = {}
) => {
  await xApiTrackingService.trackEvent(
    new OutcomesImpactReportDownloadedEvent(objectId, extensions)
  );
};

export const trackOutcomesRawDataDownloadSelected = async (
  objectId,
  extensions = {}
) => {
  await xApiTrackingService.trackEvent(
    new OutcomesRawDataDownloadSelectedEvent(objectId, extensions)
  );
};

export const trackOutcomesRawDataDownloaded = async (
  objectId,
  extensions = {}
) => {
  await xApiTrackingService.trackEvent(
    new OutcomesRawDataDownloadedEvent(objectId, extensions)
  );
};
